import React from 'react'
import { AdvisorDetailProps, FirmAdvisorProps } from '../../utils/types'
import BaseAdvisorProfile from './BaseAdvisorProfile'
import capitalizeStatesInLocation from '../../utils/capitalizeStatesInLocation'
import getSecLinkLabel from '../../utils/getSecLinkLabel'

const FirmAdvisor = ({ advisor, position }: FirmAdvisorProps) => {
  const details: AdvisorDetailProps[] = [
    advisor.email && { title: 'Email', value: 'Click to Email', link: advisor.email, isEmail: true },
    advisor.phone && { title: 'Phone', value: advisor.phone, link: advisor.phone, isPhone: true },
    advisor.location && { title: 'Location', value: capitalizeStatesInLocation(advisor.location) },
    advisor.firm_website && { title: 'Visit Website', value: 'Visit Firm Website', link: advisor.firm_website, isExternal: true },
    advisor.sec_link && { title: 'Visit Profile', value: getSecLinkLabel(advisor.sec_link), link: advisor.sec_link, isExternal: true },
    advisor.certifications && { title: 'Certifications', value: advisor.certifications }
  ].filter(Boolean) as AdvisorDetailProps[]

  return <BaseAdvisorProfile advisor={advisor} details={details} position={position}/>
}

export default FirmAdvisor
